module.exports = __webpack_public_path__ + "static/img/borne2-1.11a5232.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/borne2-1.svg
// module id = QJo8
// module chunks = 0